import { render, staticRenderFns } from "./EditReview.vue?vue&type=template&id=9e5fdea4&scoped=true"
import script from "./EditReview.vue?vue&type=script&lang=js"
export * from "./EditReview.vue?vue&type=script&lang=js"
import style0 from "./EditReview.vue?vue&type=style&index=0&id=9e5fdea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5fdea4",
  null
  
)

export default component.exports